import { AppBar, Button, Grid2, IconButton, Toolbar } from '@mui/material';
import { createStyles, WithStyles, withStyles } from '@mui/styles';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { SEND_FEEDBACK_BUTTON_ID, SIGN_IN_BUTTON_ID } from '@/constants/testIds';

import useTranslation from '../../components/hooks/useTranslation';
import Logo from '../../components/logos/Logo';
import { useOptionalPlaceContext } from '../../components/placeContext/usePlaceContext';
import Typography from '../../components/typography/Typography';
import { LOGIN_URL, PLACES, ROOT_URL } from '../../constants/RouterConstants';
import { loggedInUserSelector } from '../../store/selectors/authenticationSelectors';
import { Theme } from '../../styles/theme';
import FeedbackDialog from './FeedbackDialog';
import NavigationMenu from './NavigationMenu';

const styles = (theme: Theme) =>
  createStyles({
    logo: {
      padding: theme.spacing(1),
    },
    gridContainer: {
      flex: '1 1 auto',
    },
  });

export interface Props extends WithStyles<typeof styles> {
  title: string;
  hasError?: boolean;
  children?: React.ReactNode;
  appbarClassName?: string;
}

function Header(props: Props) {
  const { classes, title, children, appbarClassName } = props;
  const history = useHistory();
  const place = useOptionalPlaceContext();
  const loggedInUser = useSelector(loggedInUserSelector);
  const translatedStrings = useTranslation();
  const [isFeedbackDialogOpen, setIsFeedbackDialogOpen] = useState(false);
  const url = history.location.pathname;

  return (
    <AppBar position="static" color="secondary" className={appbarClassName}>
      <Toolbar>
        <Grid2 container spacing={1} justifyContent="space-between" alignItems="center" className={classes.gridContainer} wrap="nowrap">
          <Grid2>
            <Grid2 container spacing={1} wrap="nowrap" alignItems="center">
              <Grid2>
                <IconButton size="large" onClick={() => (loggedInUser ? history.push(PLACES) : history.push(ROOT_URL))} className={classes.logo}>
                  <Logo />
                </IconButton>
              </Grid2>
              {title && (
                <Grid2 sx={{ display: { xs: 'none', sm: 'flex' } }}>
                  <Typography variant="h5" color="secondary.contrastText">
                    {title}
                  </Typography>
                </Grid2>
              )}
            </Grid2>
          </Grid2>
          <Grid2>{children}</Grid2>
          <Grid2>
            <Grid2 container spacing={1} alignItems="center">
              <Grid2 sx={{ display: { xs: 'none', md: 'flex' } }}>
                <Button data-id={SEND_FEEDBACK_BUTTON_ID} variant="outlined" color="primary" onClick={() => setIsFeedbackDialogOpen(true)}>
                  {translatedStrings.sendFeedbackCallToAction}
                </Button>
              </Grid2>
              {!loggedInUser && url !== LOGIN_URL && (
                <Grid2 sx={{ display: { xs: 'none', md: 'flex' } }}>
                  <Button data-id={SIGN_IN_BUTTON_ID} variant="contained" onClick={() => history.push(LOGIN_URL)} color="primary">
                    {translatedStrings.login}
                  </Button>
                </Grid2>
              )}
              {/* TODO: #285 New reservation notification
              <Grid2 >
                {!hasError && isProtectedPage && <NotificationsContainer />}
              </Grid2> */}
              <Grid2>
                <NavigationMenu
                  place={place}
                  loggedInUser={loggedInUser}
                  translatedStrings={translatedStrings}
                  onShowFeedbackDialog={(callback) => {
                    setIsFeedbackDialogOpen(true);
                    callback();
                  }}
                />
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
        {/* <RealTimeReservationDialog></RealTimeReservationDialog> TODO 514: Find table real time/automatically */}
        <FeedbackDialog isOpen={isFeedbackDialogOpen} setOpenState={setIsFeedbackDialogOpen} />
      </Toolbar>
    </AppBar>
  );
}

export default withStyles(styles)(Header);
